import {closest} from "glightbox/src/js/utils/helpers";

export default () => {

    const forms = document.querySelectorAll('form.userform');
    const header = document.querySelector('[data-header]');
    for (const form of forms) {
        form.addEventListener('userform.action.next', () => {
            window.setTimeout(() => {
                const headerRect = header.getBoundingClientRect();
                let rect = form.getBoundingClientRect();
                if (form.querySelector('.error')) { // check whether we have any errors.
                    rect = closest(form.querySelector('.error'), '.field').getBoundingClientRect();
                }

                let dest = rect.y - (headerRect.height + 50);
                if (rect.y < 0) {
                    dest = window.scrollY - (-1 * rect.y) - (headerRect.height + 50);
                }
                window.scrollTo(0, dest);
            }, 200);
        });
    }

}

